import { render, staticRenderFns } from "./DashboardDetail.vue?vue&type=template&id=e0f6014a&"
import script from "./DashboardDetail.vue?vue&type=script&lang=js&"
export * from "./DashboardDetail.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDetail.vue?vue&type=style&index=0&id=e0f6014a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports